import { useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { addMealToDay } from "../api/plans";
import { AuthContext } from "../context/AuthContext";

const MEAL_TYPES = ["breakfast","lunch","dinner","snacks"];

const MEAL_LABELS = {
  breakfast: "Breakfast",
  lunch:     "Lunch",
  dinner:    "Dinner",
  snacks:    "Snacks"
};

function todayStr(){
  const d = new Date();
  return [
    d.getFullYear(),
    String(d.getMonth()+1).padStart(2,"0"),
    String(d.getDate()).padStart(2,"0")
  ].join("-");
}

export default function AddToPlannerPage({ meals }){

  const { mealId } = useParams();
  const navigate = useNavigate();
  const { householdId } = useContext(AuthContext);

  const meal = meals.find(m=>m.id===mealId);

  const [date, setDate] = useState(todayStr);
  const [mealType, setMealType] = useState("dinner");
  const [saving, setSaving] = useState(false);

  async function handleAdd(){
    if(!date || !mealType) return;
    setSaving(true);
    await addMealToDay(householdId, date, mealType, mealId);
    navigate("/meals", { state:{ addedToPlanner:true } });
  }

  return(

    <div className="card addToPlannerForm">

      <div className="pageHeader" style={{marginBottom:20}}>
        <h2>Add to Planner</h2>
        <button className="discardBtn" onClick={()=>navigate("/meals")}>
          ← Back
        </button>
      </div>

      {meal && (
        <div className="addToPlannerMeal">
          <span className="addToPlannerMealName">{meal.name}</span>
          {meal.servings && (
            <span className="mealServes">Serves {meal.servings}</span>
          )}
        </div>
      )}

      <div className="formGroup" style={{marginTop:20}}>
        <label>Date</label>
        <input
          type="date"
          value={date}
          onChange={e=>setDate(e.target.value)}
          style={{maxWidth:200}}
        />
      </div>

      <div className="formGroup">
        <label>Meal Type</label>
        <div className="mealTypeSelector">
          {MEAL_TYPES.map(type=>(
            <button
              key={type}
              className={`mealTypeBtn calMealType-${type}${mealType===type ? " selected" : ""}`}
              onClick={()=>setMealType(type)}
            >
              {MEAL_LABELS[type]}
            </button>
          ))}
        </div>
      </div>

      <div className="formActions" style={{marginTop:24}}>
        <button onClick={handleAdd} disabled={saving}>
          {saving ? "Adding…" : "Add to Planner"}
        </button>
        <button className="discardBtn" onClick={()=>navigate("/meals")}>
          Cancel
        </button>
      </div>

    </div>

  );

}
